<template>
  <label class="mode-switcher" title="Dark mode">
    <input type="checkbox" name="color-mode-switcher" v-model="isChecked" v-on:change="changeMode">
    <span class="mode-switcher__outer">
      <span class="mode-switcher__inner"></span>
    </span>
  </label>
</template>

<script>
export default {
  data() {
    return {
      isChecked: false
    }
  },
  beforeMount() {
    const localStorageValue = localStorage.getItem('darkMode')

    if (localStorageValue) {
      this.isChecked = true
      document.documentElement.classList.add('dark')
    } else {
      this.isChecked = false
      document.documentElement.classList.remove('dark')
    }
  },
  methods: {
    changeMode() {
      if (this.isChecked) {
        localStorage.setItem('darkMode', true)
        document.documentElement.classList.add('dark')
      } else {
        localStorage.removeItem('darkMode')
        document.documentElement.classList.remove('dark')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

.mode-switcher{
  $size: 1.2rem;
  margin: 0;
  padding: 0;
  cursor: pointer;
  height: $size;
  &__outer{
    background-color: $theme-light;
    background-color: var(--element-theme-light);
    width: $size*2;
    height: $size;
    border-radius: $size;
    display: inline-block;
    position: relative;
    transition: background-color 0.2s;
  }
  &__inner{
    width: $size;
    height: $size;
    background-color: $theme;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: $size;
    box-shadow: 0 0 0 2px $theme;
    transition: left 0.2s;
  }
  input{
    display: none;
    &:checked + .mode-switcher__outer{
      .mode-switcher__inner{
        left: $size;
      }
    }
  }
}
</style>
